import * as React from "react";
import NotificationDropdown from "./NotificationDropdown";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {NotificationType} from "../../../../model/notification/NotificationBase";

import "./notificationMenu.scss";

interface State {
	/**
	 * Is dropdown currently visible.
	 */
	dropDownVisible: boolean;
}

interface ReduxProps {
	/**
	 * Notification list.
	 */
	notifications: Array<NotificationType>
	/**
	 * Indicates of any unread notification exists
	 */
	isUnread: boolean
}

class NotificationMenu extends React.PureComponent<ReduxProps, State> {
	constructor(props: ReduxProps) {
		super(props);
		this.state = {
			dropDownVisible: false,
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.onItemLinkClick = this.onItemLinkClick.bind(this);
	}

	/**
	 * Store dropdown and button elements.
	 */
	notificationButton: HTMLSpanElement = undefined;
	notificationDropdown: HTMLDivElement = undefined;

	componentDidMount() {
		window.addEventListener("click", this.handleOutsideClick)
	}

	componentWillUnmount() {
		window.removeEventListener("click", this.handleOutsideClick)
	}

	render() {
		return (
			<div className={"c-notification-menu"}>
				<span className={"c-notification-menu_bell"}
					  ref={(elem) => this.notificationButton = elem}
					  onClick={this.toggleMenu}>
					{this.props.isUnread && <span className="c-notification-menu_bell_dot"/>}
					<img className={"c-notification-menu_bell_image"} src={"/assets/img/icons/icn-cmn-notification-active.svg"}/>
				</span>
				{this.state.dropDownVisible &&
				<div className={"c-notification-menu_dropdown"}
					 ref={(elem) => this.notificationDropdown = elem}>
					<NotificationDropdown
						notifications={this.props.notifications}
						onItemLinkClick={this.onItemLinkClick}
						isOpen={this.state.dropDownVisible}/>
				</div>
				}
			</div>
		);
	}

	/**
	 * Toggle dropdown.
	 */
	toggleMenu() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	/**
	 * On item click handler. Close dropdown on Link click.
	 */
	onItemLinkClick() {
		this.setState({dropDownVisible: false});
	}

	/**
	 * Handle click outside the drop down menu and 'bell' button.
	 * If click target not contains stored button and dropdown, this means click was targeted outside dropdown and button
	 * - then hide dropdown.
	 */
	handleOutsideClick(evt: Event) {
		if (this.state.dropDownVisible && !this.notificationButton.contains(evt.target as Node) &&
			!this.notificationDropdown.contains(evt.target as Node))
			this.setState({dropDownVisible: false});
	}
}

function mapStateToProps(state: RootState) {
	return {
		notifications: state.notification.notifications,
		isUnread: state.notification.isNotificationUnread
	};
}

export default connect(mapStateToProps)(NotificationMenu);

